import { render } from "./ModelosPropostaView.vue?vue&type=template&id=22b3e24d"
import script from "./ModelosPropostaView.vue?vue&type=script&lang=js"
export * from "./ModelosPropostaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__